import styled from 'styled-components';

interface IModalProps {
  type: 'warning' | 'generic';
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 1rem;

  .buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Content = styled.div<IModalProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .subHeader {
    display: flex;
    align-items: center;

    h1 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: ${({ theme, type }) =>
        type === 'warning' ? theme.colors.error : theme.colors.secondary};
      font-size: 1.4rem;
      margin: 0.5rem 0;

      svg {
        height: 2.5rem;
        width: 2.5rem;
        fill: ${({ theme, type }) =>
          type === 'warning' ? theme.colors.error : theme.colors.secondary};
      }
    }

    p {
      font-size: 1.1rem;
      color: ${({ theme }) => theme.colors.text};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;
    align-self: start;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;
